const Style = {
  overlay: {
    backdropFilter: 'blur(2px)',
  },

  content: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '18em',
    minWidth: '10em',
    padding: '2em',
    paddingTop: '1em',
    paddingRight: '1em',
    direction: 'rtl',
    overflowY: 'hidden',
  },
};
export default Style;
